import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'toolName', pure: true, standalone: true })
export class ToolNamePipe implements PipeTransform {
	private readonly translate = inject(TranslateService);

	transform(toolName: string | undefined): string {
		if (!toolName) return '';

		const translationKey = `toolNames.${toolName}`;
		const translated = this.translate.instant(translationKey);

		if (translated === translationKey) {
			return toolName.replace(/_/g, ' ');
		}

		return translated;
	}
}
